import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7f8da88"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "el-dialog__body-title"
}
const _hoisted_2 = {
  key: 1,
  class: "el-dialog__body-title"
}
const _hoisted_3 = { class: "problem" }
const _hoisted_4 = {
  class: "flex abormal-flex",
  style: {"padding-top":"10px"}
}
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "content"
}
const _hoisted_7 = { class: "shopping-item name" }
const _hoisted_8 = {
  key: 1,
  class: "content"
}
const _hoisted_9 = { class: "shopping-item name" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "flex abormal-flex" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "content" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "flex abormal-flex" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = {
  key: 0,
  class: "form",
  style: {"padding":"20px 30px 0","border-top":"1px solid #F9F9F9"}
}
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "tip" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { style: {"width":"100%"} }
const _hoisted_27 = { style: {"width":"100%"} }
const _hoisted_28 = { style: {"width":"100%"} }
const _hoisted_29 = { style: {"width":"100%"} }
const _hoisted_30 = {
  key: 0,
  style: {"display":"flex","flex-wrap":"wrap"}
}
const _hoisted_31 = { style: {"margin-left":"20px"} }
const _hoisted_32 = {
  class: "line--only",
  style: {"width":"100%","max-width":"600px"}
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "rel" }
const _hoisted_36 = {
  key: 0,
  class: "check-sku abs"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = {
  key: 3,
  style: {"padding-top":"20px","margin-top":"20px","border-top":"1px solid #f9f9f9"}
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  style: {"margin-left":"20px"},
  class: "rel"
}
const _hoisted_44 = {
  key: 0,
  class: "check-sku abs"
}
const _hoisted_45 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { style: {"margin-left":"20px"} }
const _hoisted_48 = {
  class: "line--only",
  style: {"width":"100%","max-width":"600px"}
}
const _hoisted_49 = { key: 1 }
const _hoisted_50 = ["innerHTML"]
const _hoisted_51 = {
  key: 0,
  style: {"margin-left":"20px"}
}
const _hoisted_52 = ["href"]
const _hoisted_53 = { key: 2 }
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = {
  key: 0,
  style: {"margin-left":"20px"}
}
const _hoisted_56 = { key: 3 }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { key: 4 }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = { key: 5 }
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = {
  key: 6,
  style: {"padding-top":"20px","margin-top":"20px","border-top":"1px solid #f9f9f9"}
}
const _hoisted_63 = { class: "title" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = {
  key: 1,
  class: "flex abormal-flex",
  style: {"padding-bottom":"10px","border-top":"1px solid #F9F9F9","padding-top":"20px"}
}
const _hoisted_67 = { class: "title" }
const _hoisted_68 = {
  class: "content",
  style: {"background":"#FCFCFC","padding":"15px 10px","min-height":"90px"}
}
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { key: 2 }
const _hoisted_72 = ["innerHTML"]
const _hoisted_73 = ["innerHTML"]
const _hoisted_74 = { key: 3 }
const _hoisted_75 = { key: 4 }
const _hoisted_76 = { key: 5 }
const _hoisted_77 = { key: 6 }
const _hoisted_78 = { key: 7 }
const _hoisted_79 = { key: 8 }
const _hoisted_80 = { key: 9 }
const _hoisted_81 = ["innerHTML"]
const _hoisted_82 = ["href"]
const _hoisted_83 = { key: 10 }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 11 }
const _hoisted_86 = ["innerHTML"]
const _hoisted_87 = ["href"]
const _hoisted_88 = { key: 12 }
const _hoisted_89 = ["innerHTML"]
const _hoisted_90 = ["href"]
const _hoisted_91 = { key: 13 }
const _hoisted_92 = ["innerHTML"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_94 = { key: 15 }
const _hoisted_95 = ["innerHTML"]
const _hoisted_96 = { key: 16 }
const _hoisted_97 = ["innerHTML"]
const _hoisted_98 = { key: 17 }
const _hoisted_99 = { key: 18 }
const _hoisted_100 = { style: {"width":"600px"} }
const _hoisted_101 = { key: 20 }
const _hoisted_102 = {
  key: 2,
  class: "el-dialog__body-footer flex-ter-end"
}
const _hoisted_103 = {
  key: 3,
  style: {"text-align":"center","padding-top":"10px","padding-bottom":"10px"}
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-dialog__body-title" }, null, -1))
const _hoisted_105 = { class: "warning mb_10" }

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed } from 'vue'
import AppLink from '@/components/common/AppLink.vue'
import productTable from './components/productTable.vue'
import { problemHandling, backendProduct, backendProductSku, searchAll, getUserPurchaseAbnormalExtentApi, getUserPurchaseAbnormalPdd, getPlatformOrderItem, getAbnormalDetailApi } from '@/apis/order'
import CarouselImg from './CarouselImg.vue'
import { ElMessage } from 'element-plus'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { WarningFilled } from '@element-plus/icons-vue'
import { isD2C } from '@/store'
import ProductSku from './components/ProductSku.vue'
import AbnormalGoodsTip from '@/components/common/AbnormalGoodsTip.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  onlyRead: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit: emits }) {

const props = __props



const isHaveShopPurchase = ref(0)
const productSellPrice = ref('')
const showSku = ref(false)
// PDD数据
const originalPricePDD = ref()
const groupBookingPricePdd = ref()
const goodNumPDD = ref()
const userChooseConfirmOriginalPrice = ref()

watch(() => props.visible, (newValue) => {
  if (newValue) {
    init()
    if ([1, 2, 3].includes(props.rowItem.abnormalDetailType)) {
      getBackendProduct()
    }
    if ([4, 5].includes(props.rowItem.abnormalDetailType)) {
      getBackendProductSku()
    }
    if (props.rowItem.type === 8 || props.rowItem.type === 12 || props.rowItem.type === 10) {
      // 获取状态和价格
      getUserPurchaseAbnormalExtentApi({
        purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId
      }).then((res: any) => {
        isHaveShopPurchase.value = res.data.isHaveShopPurchase
        productSellPrice.value = res.data.productSellPrice
      })
    }
    // 进入PDD流程
    if (props.rowItem.abnormalDetailType === 14 && props.rowItem.type === 1) {
      getUserPurchaseAbnormalPdd({
        purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId
      }).then((res: any) => {
        originalPricePDD.value = res.data.originalPrice
        groupBookingPricePdd.value = res.data.groupBookingPrice
        goodNumPDD.value = res.data.goodNum
        userChooseConfirmOriginalPrice.value = res.data.userChooseConfirmOriginalPrice
      })
    }
  }
})
// 获取采购商品详情
const getBackendProductSku = () => {
  const { purchaseUserProductSku } = toRaw(props.rowItem)
  backendProductSku({
    productSku: purchaseUserProductSku
  }).then((res: any) => {
    for (const e of (res.data.skuList || [])) {
      if (e.productSku === purchaseUserProductSku) {
        console.log('e', e)
        const properties = e.productPropertiesName.split(';').map((v: any) => v.replace(/[+-]?\d+:[+-]?\d+:/, ''))
        checkedProduct.value = {
          productSku: e.productSku,
          productCode: e.productCode,
          props: properties.join(' '),
          link: res.data.productDetailUrl,
          price: e.productSellPrice
        }
        break
      }
    }
  })
}
const getBackendProduct = () => {
  const { productCode, productSku } = toRaw(props.rowItem)
  backendProduct({
    productCode
  }).then(res => {
    const list = (res.data.skuList || []).map((e: any) => {
      const properties = e.productPropertiesName.split(';').map((v: any) => v.replace(/[+-]?\d+:[+-]?\d+:/, ''))
      if (e.productSku === productSku) {
        checkedProduct.value = {
          productSku: e.productSku,
          productCode: e.productCode,
          props: properties.join(' '),
          link: res.data.productDetailUrl
        }
      }
      return ({
        productSku: e.productSku,
        productCode: e.productCode,
        props: properties.join(' '),
        link: res.data.productDetailUrl
      })
    })
    productSkuList.value = list
  })
}

const showSearch = ref(false)
const searchLoading = ref(false)

const getList = (type?: boolean) => {
  return new Promise((resolve) => {
    const fn = () => {
      searchAll({ detailUrl: customerProductLink.value }).then(res => {
        resolve(res)
      })
    }
    type ? setTimeout(fn, 500) : fn()
  })
}
const productInfo = ref({})
const cb = async (type?: boolean) => {
  const res: any = await getList(type)
  if (res.success) {
    if (res.data?.skuList.length) {
      productInfo.value = res.data
      searchSkuList.value = (res.data.skuList || []).map((e: any) => {
        const properties = e.productPropertiesName.split(';').map((v: any) => v.replace(/[+-]?\d+:[+-]?\d+:/, ''))
        return ({
          productSku: e.productSku,
          productCode: e.productCode,
          props: properties.join(' '),
          link: res.data.productDetailUrl
        })
      })
    } else {
      const bool = true
      await cb(bool)
    }
  }
}

const searchUrl = async () => {
  if (!customerProductLink.value) return ElMessage.warning(t('请输入链接'))
  searchLoading.value = true
  try {
    await cb()
    showSearch.value = true
    searchLoading.value = false
  } catch (error) {
    searchLoading.value = false
  }
}

const imgList = computed(() => {
  return props.rowItem.imageList?.length > 0 ? props.rowItem.imageList : [props.rowItem.productImg]
})

const checkedProduct: any = ref()
const productSkuList: any = ref([])
const searchSkuList: any = ref([])

const customerOperateType = ref()
const customerProductLink = ref()
const customerProductSku = ref()
const payRepurchaseType = ref(true)

watch(() => customerOperateType, () => {
  showSearch.value = true
})

const init = () => {
  checkedProduct.value = {}
  productSkuList.value = []
  searchSkuList.value = []
  customerOperateType.value = ''
  customerProductLink.value = ''
  customerProductSku.value = ''
  payRepurchaseType.value = true
  toEditShopPurchase.value = false
  originalPricePDD.value = ''
  groupBookingPricePdd.value = ''
  goodNumPDD.value = ''
  userChooseConfirmOriginalPrice.value = ''
  isTotalFinish.value = false
  showSearch.value = false
  tableData.value = []
  groupVisible.value = false
  // groupAbnormal.value = ''

  getGroupData()
}

const getParams = () => {
  if (customerOperateType.value === 4) {
    if (!customerProductLink.value) {
      ElMessage.warning(t('请输入链接'))
      return false
    }
  }
  const { purchaseAbnormalOrderId, purchaseUserProductLink, purchaseUserProductSku } = toRaw(props.rowItem)
  const obj: any = {
    purchaseAbnormalOrderId,
    customerOperateType: customerOperateType.value
  }
  if (customerOperateType.value === 5) {
    return obj
  }
  // 更换 颜色尺码款式时 取消商品不传sku 其他都需要传sku
  if ([1, 2, 3].includes(customerOperateType.value)) {
    const v = productSkuList.value.find((e: any) => e.productSku === customerProductSku.value)
    obj.customerProductLink = v?.link ?? ''
    obj.customerProductSku = v?.productSku ?? ''
    return obj
  }
  if (customerOperateType.value === 4 || customerOperateType.value === 15) {
    const v = searchSkuList.value.find((e: any) => e.productSku === customerProductSku.value)
    obj.customerProductLink = v?.link ?? ''
    obj.customerProductSku = v?.productSku ?? ''
    return obj
  }
  if ([6, 7].includes(customerOperateType.value)) {
    obj.customerProductSku = purchaseUserProductSku
    obj.customerProductLink = purchaseUserProductLink
    return obj
  }
  // showDefectiveProduct和组合直发单有重合 是组合直发的话不return
  if (showDefectiveProduct.value && !isgroup.value) {
    if (props.rowItem.payRepurchaseType !== 1 && payRepurchaseType.value) {
      obj.payRepurchaseType = isD2C() ? 1 : 2
    }
    return obj
  }
  if (props.rowItem.abnormalDetailType === 14) {
    obj.purchaseSkuRespDTO = {
      userChooseConfirmOriginalPrice: userChooseConfirmOriginalPrice.value
    }
  }
  if (isgroup.value && customerOperateType.value === 18) {
    obj.itemDetails = tableData.value.map((v:any) => {
      return {
        purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId,
        platformOrderNo: props.rowItem.platformOrderNo,
        platformOrderItemId: v.platformOrderItemId,
        productSku: v.productSku,
        productName: v.productTitle,
        productImg: v.productSkuImg,
        productLink: v.productDetailUrl,
        productProp: v.productPropertiesName,
        num: v.orderQuantity,
        dealType: v.dealType
      }
    })
    // 兼容showDefectiveProduct
    if (props.rowItem.payRepurchaseType !== 1 && payRepurchaseType.value) {
      obj.payRepurchaseType = 1
    }
  }
  return obj
}
let firstParams: any = ''
const toEditShopPurchase = ref(false)
const isTotalFinish = ref(false) // 是否重拍上限
const submit = () => {
  if (!customerOperateType.value) return ElMessage.warning(t('请选择处理方式'))
  const params: any = getParams()
  if (params) {
    if (params.customerOperateType === 15 && !params.customerProductLink) {
      return ElMessage.warning(t('请输入链接'))
    }
    // 不需要判断是否配置10.31需求
    // if (props.rowItem.type === 8 && isHaveShopPurchase.value === 0 && !toEditShopPurchase.value && getParams().customerOperateType === 12) {
    //   // 异常 没有配置&& 不良品 跳转配置
    //   toEditShopPurchase.value = true
    //   firstParams = JSON.parse(JSON.stringify(getParams()))
    //   return
    // }
    // 不需要判断是否配置10.31需求
    // if (params.customerOperateType === 6) {
    //   // 同款链接加link和sku字段
    //   params.customerProductSku = props.rowItem.productSku
    //   params.customerProductLink = props.rowItem.productLink
    // }
    problemHandling(firstParams || params).then((res: any) => {
      if (res.success) {
        if (firstParams) {
          problemHandling(getParams()).then((res: any) => {
            ElMessage.success(t('申请成功'))
            emits('update:visible', false)
            emits('refresh')
          })
        } else {
          ElMessage.success(t('申请成功'))
          emits('update:visible', false)
          emits('refresh')
        }
        firstParams = ''
        toEditShopPurchase.value = false
      } else {
        console.log(res)
        if (res.code === '20000023') {
          // 重拍上限
          isTotalFinish.value = true
          customerOperateType.value = ''
        }
      }
    }).catch((error: any) => {
      console.log(error)
    })
  }
}

const showDefectiveProduct = computed(() => {
  //  7 次品件
  return props.rowItem.type === 7
})

const showAbnormalParts = computed(() => {
  // 8 异常件
  return props.rowItem.type === 8
})

const showContentList = computed(() => {
  const { type, abnormalDetailType, userExpected, remark, purchaseUserProductLink, changeLinkSellPrice } = props.rowItem
  // ("type 异常类型 1 商品确认 2 全网断货 3 原商品缺货 4 预售商品 5 不满足最小起订量 6 更换采购链接 7 次品件 8 异常次品件 9 客户退款 10 到错货 11 多件 12 少件 13 扫不出 14 商品下架 15 商品异常")
  switch (type) {
    case 1:
      switch (abnormalDetailType) {
        case 1:
          return [t('确认尺码')]
        case 2:
          return [t('确认颜色')]
        case 3:
          return [t('确认款式')]
        case 14:
          return [t('无法按拼团价进行采购，需按原价进行采购')]
        default:
          return []
      }
    case 2:
      return [t('全网断货')]
    case 3:
      switch (abnormalDetailType) {
        case 4:
          return !userExpected ? [t('原商品缺货-推荐同款-价格不符合客户预期').replace('X', checkedProduct.value.price ?? 0).replaceAll('H', purchaseUserProductLink)] : []
        case 5:
          return [t('原商品缺货-推荐类似款').replace('X', checkedProduct.value.price ?? 0).replaceAll('H', purchaseUserProductLink)]
        default:
          return []
      }
    case 4:
      switch (abnormalDetailType) {
        case 4:
          return [t('预售商品-推荐同款商品').replace('X', remark ?? 0).replaceAll('H', purchaseUserProductLink)]
        case 6:
          return [t('预售商品-无同款商品推荐').replace('X', remark ?? 0)]
        default:
          return []
      }
    case 5:
      switch (abnormalDetailType) {
        case 4:
          return [t('不满足最小起量-推荐同款商品').replace('X', remark ?? 0).replace('Y', props.rowItem.num).replaceAll('H', purchaseUserProductLink)]
        case 6:
          return [t('不满足最小起量-无同款商品推荐').replace('X', remark ?? 0).replace('Y', props.rowItem.num)]
        default:
          return []
      }
    case 6:
      return !userExpected ? [t('更换同款链接-价格不符合客户预期').replaceAll('H', purchaseUserProductLink)] : []
    case 7:
    case 8:
      return getDefectiveProductContent()
    case 10:
      // 未配置次品付费重拍和配置文案区分
      return [(isHaveShopPurchase.value === 0 ? t('因原商品质量不佳，我们为您自动寻找了以下新链接，请您确认是否需要再新链接下重拍') : t('因原商品质量不佳，我们为您重拍时自动寻找了以下新链接，但新链接价格不符合您的预期，请您确认')).replace('X', productSellPrice.value).replaceAll('H', purchaseUserProductLink)]
    case 12:
      return [t('原URL缺货，新的URL内商品是X元，请确认').replace('X', productSellPrice.value).replaceAll('H', purchaseUserProductLink)]
    default:
      return []
  }
})

const getDefectiveProductContent = () => {
  const { abnormalDetailMessageJp } = props.rowItem
  const content: string[] = []
  abnormalDetailMessageJp.split(',').forEach((e: string) => {
    content.push(defectiveAbnormalDict[e] || '')
  })
  return content
}

const defectiveAbnormalDict: any = {
  101: t('到错货'),
  102: t('少件'),
  103: t('多件'),
  104: t('快递扫不出'),
  201: t('颜色差异'),
  202: t('商品上有中文'),
  203: t('配件差异'),
  204: t('logo差异'),
  205: t('尺码差异'),
  206: t('设计差异'),
  207: t('材质、面料差异'),
  301: t('$色差$'),
  302: t('$污渍/斑点/水印$'),
  303: t('$破损$'),
  304: t('$线头$'),
  305: t('$接缝不良$'),
  306: t('$抽丝$'),
  307: t('$针眼$'),
  308: t('$霉菌$'),
  309: t('$生锈$'),
  310: t('$商品有中文$'),
  311: t('$纽扣破损$'),
  312: t('$拉链破损$'),
  313: t('$附属品缺陷$'),
  314: t('$有气味$'),
  315: t('$其他不良$'),
  316: t('$通电不良$')
}

//  翻译转换
const cT = computed(() => {
  const { type, orderType, customerOperateType } = props.rowItem
  const defaultObj: any = {
    取消商品: t('取消商品采购'), // 囤货
    换个链接: t('请在我指定的新链接下采购'),
    同款链接: t('请在THE CKB为我推荐的此链接下采购'),
    等待原链接: t('可以等待，请继续在原链接采购'),
    类似款链接: t('请在THE CKB为我推荐的此链接下采购'),
    下单原链接: t('我接受起订量，请继续在原链接采购'),
    '下单原链接（多出数量保留库存）': t('我接受起订量，请继续在原链接采购'),
    良品入库: t('问题不大，我能接受，请当成良品入库'),
    不良品: t('此问题我不能接受，请依然当成不良品处理')
  }
  defaultObj['取消商品'] = orderType === 2 ? t('取消商品采购') : t('取消商品采购+商品发送')
  // 商品确认
  if (type === 1) {
    defaultObj['换个链接'] = t('请在我指定的新链接购买')
  }
  // 全网断货
  if (type === 2) {
    defaultObj['换个链接'] = t('我有可能有货的采购链接，请在这个链接再尝试购买')
  }
  // 预售商品
  if (type === 4) {
    defaultObj['换个链接'] = t('我等不及，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('我等不及，请在THE CKB为我推荐的此链接下采购')
  }
  // 不满足最小起订量
  if (type === 5) {
    defaultObj['换个链接'] = t('我不接受起订量，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('我不接受起订量，请在THE CKB为我推荐的此链接下采购')
    defaultObj['下单原链接'] = t('我接受起订量，请继续在原链接采购（多采部分商品无异常上架后将作为库存在THE CKB仓库代为保管，并可匹配其他直发订单发出）')
  }
  // 更换同款链接
  if (type === 6) {
    defaultObj['换个链接'] = t('THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购')
    defaultObj['同款链接'] = t('请在THE CKB为我推荐的此链接下采购')
    defaultObj['下单原链接'] = t('我还是要继续在原链接采购')
  }
  // 次品
  if (type === 7) {
    defaultObj['取消商品'] = orderType === 2 ? t('次品退货退款并取消商品采购') : t('次品退货退款并取消商品采购+商品发送')
    if (customerOperateType !== 0) {
      // 异常处理完查看详情type 8 会转为7
      defaultObj['换个链接'] = t('此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买')
      defaultObj['取消商品'] = orderType === 2 ? t('此问题我不能接受，请依然当成不良品处理，并取消商品采购') : t('此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送')
    }
  }
  // 异常
  if (type === 8) {
    defaultObj['换个链接'] = t('此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买')
    defaultObj['取消商品'] = orderType === 2 ? t('此问题我不能接受，请依然当成不良品处理，并取消商品采购') : t('此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送')
  }
  // 倒错货
  if (type === 10) {
    defaultObj['换个链接'] = t('THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购')
    defaultObj['取消商品'] = orderType === 2 ? t('取消商品重拍') : t('取消商品重拍+商品发送')
  }
  // 少件
  if (type === 12) {
    defaultObj['取消商品'] = orderType === 2 ? t('取消商品重拍') : t('取消商品重拍+商品发送')
  }
  return (t: any) => {
    return defaultObj[t]
  }
})

// 组合直发
// const groupAbnormal = ref('')
const isgroup = computed(() => {
  //      是否直发      是否重拍               采购配置              重拍上限           仓库异常   客户配置         是否是转成囤货单
  const { orderType, purchaseRemakeStatus, purchaseOperateType, reachMaxRemakeTimes, type, payRepurchaseType, transformStockStatus } = props.rowItem
  if (orderType !== 1 && transformStockStatus !== 1) {
    return false
  }
  if (type === 7 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 7 && payRepurchaseType === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 12 && purchaseOperateType === 35 && reachMaxRemakeTimes === 0) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  if (type === 10 && reachMaxRemakeTimes === 1 && purchaseRemakeStatus === 1) {
    // groupAbnormal.value = '次品重拍达到上限'
    return '次品重拍达到上限'
  }
  if (type === 10 && payRepurchaseType === 2 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '由于您选择次品退货退款，未触发次品重拍'
    return '由于您选择次品退货退款，未触发次品重拍'
  }
  if (type === 10 && purchaseRemakeStatus === 2) {
    // groupAbnormal.value = '全网断货'
    return '$全网断货$'
  }
  return false
})
const groupVisible = ref(false)
const radioGroupChange = (e) => {
  if (e !== 4) {
    groupVisible.value = true
  }
}
const tableData = ref([])
const getGroupData = () => {
  if (!isgroup.value) {
    return
  }
  if (props.onlyRead) {
    getAbnormalDetailApi({ purchaseAbnormalOrderId: props.rowItem.purchaseAbnormalOrderId }).then(res => {
      if (res.success) {
        res.data.itemDetails.forEach((v:any) => {
          v.productMainImg = v.productImg
          v.productPropertiesName = v.productProp
          v.orderQuantity = v.num
          v.orderItemStatusList = []
        })
        tableData.value = res.data.itemDetails
      }
    })
  } else {
    getPlatformOrderItem({ platformOrderId: props.rowItem.platformOrderId, source: 2 }).then(res => {
      if (res.success) {
        res.data.forEach((v:any) => {
          v.dealType = 1
        })
        tableData.value = res.data
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "problem-dialog",
    "destroy-on-close": "",
    "model-value": __props.visible,
    onClose: _cache[41] || (_cache[41] = ($event: any) => (emits('update:visible', false))),
    draggable: "",
    "append-to-body": true
  }, {
    default: _withCtx(() => [
      (!__props.onlyRead)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('处理详情')), 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('商品问题原因')), 1),
          (_unref(isgroup))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)(_unref(isgroup))), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showContentList), (l) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: l,
                      style: {"margin":"0"}
                    }, [
                      _createElementVNode("span", {
                        innerHTML: l,
                        style: {"word-break":"break-all"}
                      }, null, 8, _hoisted_10)
                    ]))
                  }), 128))
                ]),
                (__props.rowItem.abnormalDetailType === 14)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(t)('原价')) + ": " + _toDisplayString(originalPricePDD.value), 1))
                  : _createCommentVNode("", true),
                _hoisted_12,
                (__props.rowItem.abnormalDetailType === 14)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(t)('拼团价')) + ": " + _toDisplayString(groupBookingPricePdd.value), 1))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('商品信息')), 1),
          _createElementVNode("div", _hoisted_16, [
            (_unref(imgList)?.length > 1)
              ? (_openBlock(), _createBlock(CarouselImg, {
                  key: 0,
                  imgs: _unref(imgList)
                }, null, 8, ["imgs"]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _unref(imgList)[0],
                  target: "_blank",
                  class: "rel prew-img"
                }, [
                  _createVNode(_component_el_image, {
                    referrerPolicy: "no-referrer",
                    class: "shopping-img",
                    lazy: "",
                    "data-goods": "",
                    src: _unref(imgList)[0]
                  }, null, 8, ["src"]),
                  _createElementVNode("img", {
                    referrerPolicy: "no-referrer",
                    class: "big-img abs",
                    lazy: "",
                    "data-goods": "",
                    src: _unref(imgList)[0]
                  }, null, 8, _hoisted_18),
                  _createVNode(SvgIcon, {
                    name: "放大",
                    class: "abs icon1",
                    style: {"bottom":"4px","right":"4px","font-size":"20px"}
                  }),
                  _createVNode(SvgIcon, {
                    name: "放大_active",
                    class: "abs icon2",
                    style: {"bottom":"4px","right":"4px","font-size":"20px"}
                  })
                ], 8, _hoisted_17))
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('商品数量')), 1),
          _createElementVNode("div", _hoisted_21, _toDisplayString(__props.rowItem.num || 0), 1)
        ]),
        (!__props.onlyRead)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_unref(isgroup))
                ? (_openBlock(), _createBlock(productTable, {
                    key: 0,
                    tableData: tableData.value,
                    style: {"margin":"0 auto 20px auto","width":"740px"}
                  }, null, 8, ["tableData"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                _createTextVNode(_toDisplayString(toEditShopPurchase.value ? _unref(t)('不良品') : '') + " " + _toDisplayString(_unref(t)('请选择处理方式')), 1),
                _createElementVNode("span", _hoisted_24, "（" + _toDisplayString(_unref(t)('只可选择一种')) + "）", 1)
              ]),
              (_unref(isgroup))
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: customerOperateType.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerOperateType).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_26, [
                          (props.rowItem.customerOptionList.includes(16))
                            ? (_openBlock(), _createBlock(_component_el_radio, {
                                key: 0,
                                label: 16,
                                onClick: radioGroupChange
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）正常发货')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (props.rowItem.customerOptionList.includes(17))
                            ? (_openBlock(), _createBlock(_component_el_radio, {
                                key: 0,
                                label: 17,
                                onClick: radioGroupChange
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）也取消发货，转为库存')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          (props.rowItem.customerOptionList.includes(18))
                            ? (_openBlock(), _createBlock(_component_el_radio, {
                                key: 0,
                                label: 18,
                                onClick: radioGroupChange
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）自定义发货或转为库存')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          (props.rowItem.customerOptionList.includes(4))
                            ? (_openBlock(), _createBlock(_component_el_radio, {
                                key: 0,
                                label: 4
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('该商品不取消采购和发货，在我指定的新链接继续购买')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (customerOperateType.value === 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _withDirectives(_createElementVNode("span", null, [
                            _createVNode(_component_el_input, {
                              modelValue: customerProductLink.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customerProductLink).value = $event)),
                              placeholder: _unref(t)('请输入链接(必填)'),
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (showSearch.value = false)),
                              style: {"width":"300px"}
                            }, null, 8, ["modelValue", "placeholder"]),
                            _createVNode(_component_el_button, {
                              loading: searchLoading.value,
                              type: "primary",
                              style: {"margin-left":"6px"},
                              onClick: searchUrl
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ], 512), [
                            [_vShow, customerOperateType.value === 4]
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchSkuList.value, (v) => {
                              return (_openBlock(), _createBlock(_component_el_button, {
                                style: {"margin":"6px"},
                                type: v.productSku === customerProductSku.value ? 'primary' : 'default',
                                key: v.productSku,
                                onClick: ($event: any) => (customerProductSku.value = v.productSku)
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_32, _toDisplayString(v.props), 1)
                                ]),
                                _: 2
                              }, 1032, ["type", "onClick"]))
                            }), 128))
                          ], 512), [
                            [_vShow, showSearch.value]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_unref(showAbnormalParts) && !toEditShopPurchase.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_el_radio, {
                          modelValue: customerOperateType.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customerOperateType).value = $event)),
                          label: 11
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(cT)('良品入库')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      (__props.rowItem.type === 8 && !isTotalFinish.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createVNode(_component_el_radio, {
                              modelValue: customerOperateType.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customerOperateType).value = $event)),
                              label: 15,
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (customerProductSku.value = ''))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  innerHTML: _unref(cT)('换个链接')
                                }, null, 8, _hoisted_34)
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _withDirectives(_createElementVNode("span", null, [
                              _createVNode(_component_el_input, {
                                modelValue: customerProductLink.value,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customerProductLink).value = $event)),
                                placeholder: _unref(t)('请输入链接(必填)'),
                                onChange: _cache[7] || (_cache[7] = ($event: any) => (showSearch.value = false)),
                                style: {"width":"300px"}
                              }, null, 8, ["modelValue", "placeholder"]),
                              _createVNode(_component_el_button, {
                                loading: searchLoading.value,
                                style: {"margin-left":"6px"},
                                onClick: searchUrl,
                                type: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ], 512), [
                              [_vShow, customerOperateType.value === 15]
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_35, [
                              _createVNode(AbnormalGoodsTip, {
                                style: {"margin":"10px 0"},
                                "product-code": searchSkuList.value && searchSkuList.value[0]?.productCode,
                                product: productInfo.value
                              }, null, 8, ["product-code", "product"]),
                              _createVNode(_component_el_button, {
                                style: {"width":"100%","height":"36px"},
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (showSku.value = !showSku.value))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString((searchSkuList.value.filter((v) => v.productSku === customerProductSku.value)[0]?.props) || _unref(t)('请选择')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_Transition, { name: "el-zoom-in-top" }, {
                                default: _withCtx(() => [
                                  (showSku.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createVNode(ProductSku, {
                                          skuList: searchSkuList.value,
                                          onChange: _cache[9] || (_cache[9] = (sku) => { customerProductSku.value = sku }),
                                          onClose: _cache[10] || (_cache[10] = ($event: any) => (showSku.value = false)),
                                          checkSku: customerProductSku.value
                                        }, null, 8, ["skuList", "checkSku"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ], 512), [
                              [_vShow, showSearch.value]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (__props.rowItem.type === 8)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                            _createVNode(_component_el_radio, {
                              modelValue: customerOperateType.value,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((customerOperateType).value = $event)),
                              label: 5
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(cT)('取消商品')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_38, [
                            _createVNode(_component_el_radio, {
                              modelValue: customerOperateType.value,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((customerOperateType).value = $event)),
                              label: 12
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(cT)('不良品')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                    ], 64))
                  : (_unref(showDefectiveProduct) || toEditShopPurchase.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createVNode(_component_el_radio, {
                          modelValue: customerOperateType.value,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((customerOperateType).value = $event)),
                          label: 13
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('次品退货退款并付费重拍')) + " (" + _toDisplayString(_unref(t)('本次重拍费用X円').replace('X',
                __props.rowItem.remakeMoney || 0)) + ")", 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (__props.rowItem.payRepurchaseType !== 1 && (customerOperateType.value === 13))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_40, [
                              _createVNode(_component_el_checkbox, {
                                disabled: !(customerOperateType.value === 13),
                                modelValue: payRepurchaseType.value,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((payRepurchaseType).value = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    innerHTML: _unref(isD2C)() ? _unref(t)('以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。') : _unref(t)('以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。')
                                  }, null, 8, _hoisted_41)
                                ]),
                                _: 1
                              }, 8, ["disabled", "modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_radio, {
                          modelValue: customerOperateType.value,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((customerOperateType).value = $event)),
                          label: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(cT)('取消商品')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]))
                    : (__props.rowItem.abnormalDetailType === 14 && __props.rowItem.type === 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createElementVNode("p", null, [
                            _createVNode(_component_el_radio, {
                              modelValue: customerOperateType.value,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((customerOperateType).value = $event)),
                              label: 14
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('按原价采购')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("p", null, [
                            _createVNode(_component_el_radio, {
                              modelValue: customerOperateType.value,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((customerOperateType).value = $event)),
                              label: 5
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(cT)('取消商品')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          ([1, 2, 3].includes(__props.rowItem.abnormalDetailType))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                (__props.rowItem.abnormalDetailType === 1)
                                  ? (_openBlock(), _createBlock(_component_el_radio, {
                                      key: 0,
                                      modelValue: customerOperateType.value,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((customerOperateType).value = $event)),
                                      label: 2,
                                      onClick: _cache[19] || (_cache[19] = ($event: any) => (customerProductSku.value = __props.rowItem.productSku))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)('更换尺码')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]))
                                  : _createCommentVNode("", true),
                                (__props.rowItem.abnormalDetailType === 2)
                                  ? (_openBlock(), _createBlock(_component_el_radio, {
                                      key: 1,
                                      modelValue: customerOperateType.value,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((customerOperateType).value = $event)),
                                      label: 1,
                                      onClick: _cache[21] || (_cache[21] = ($event: any) => (customerProductSku.value = __props.rowItem.productSku))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)('更换颜色')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]))
                                  : _createCommentVNode("", true),
                                (__props.rowItem.abnormalDetailType === 3)
                                  ? (_openBlock(), _createBlock(_component_el_radio, {
                                      key: 2,
                                      modelValue: customerOperateType.value,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((customerOperateType).value = $event)),
                                      label: 3,
                                      onClick: _cache[23] || (_cache[23] = ($event: any) => (customerProductSku.value = __props.rowItem.productSku))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)('更换款式')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]))
                                  : _createCommentVNode("", true),
                                _withDirectives(_createElementVNode("div", _hoisted_43, [
                                  _createVNode(_component_el_button, {
                                    style: {"width":"350px","height":"36px"},
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (showSku.value = !showSku.value))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString((productSkuList.value.filter((v) => v.productSku === customerProductSku.value)[0]?.props) || _unref(t)('请选择')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_Transition, { name: "el-zoom-in-top" }, {
                                    default: _withCtx(() => [
                                      (showSku.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            _createVNode(ProductSku, {
                                              skuList: productSkuList.value,
                                              onChange: _cache[25] || (_cache[25] = (sku) => { customerProductSku.value = sku }),
                                              onClose: _cache[26] || (_cache[26] = ($event: any) => (showSku.value = false)),
                                              checkSku: customerProductSku.value
                                            }, null, 8, ["skuList", "checkSku"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ], 512), [
                                  [_vShow, [1, 2, 3].includes(customerOperateType.value)]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_radio, {
                              modelValue: customerOperateType.value,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((customerOperateType).value = $event)),
                              label: 5
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(cT)('取消商品')), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_el_radio, {
                              modelValue: customerOperateType.value,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((customerOperateType).value = $event)),
                              label: 4,
                              onClick: _cache[29] || (_cache[29] = ($event: any) => (customerProductSku.value = ''))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  innerHTML: _unref(cT)('换个链接')
                                }, null, 8, _hoisted_46)
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _withDirectives(_createElementVNode("span", null, [
                              _createVNode(_component_el_input, {
                                modelValue: customerProductLink.value,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((customerProductLink).value = $event)),
                                placeholder: _unref(t)('请输入链接(必填)'),
                                onChange: _cache[31] || (_cache[31] = ($event: any) => (showSearch.value = false)),
                                style: {"width":"300px"}
                              }, null, 8, ["modelValue", "placeholder"]),
                              _createVNode(_component_el_button, {
                                loading: searchLoading.value,
                                type: "primary",
                                style: {"margin-left":"6px"},
                                onClick: searchUrl
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ], 512), [
                              [_vShow, customerOperateType.value === 4]
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_47, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchSkuList.value, (v) => {
                                return (_openBlock(), _createBlock(_component_el_button, {
                                  style: {"margin":"6px"},
                                  type: v.productSku === customerProductSku.value ? 'primary' : 'default',
                                  key: v.productSku,
                                  onClick: ($event: any) => (customerProductSku.value = v.productSku)
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_48, _toDisplayString(v.props), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type", "onClick"]))
                              }), 128))
                            ], 512), [
                              [_vShow, showSearch.value]
                            ])
                          ]),
                          (__props.rowItem.abnormalDetailType === 4 || __props.rowItem.abnormalDetailType === 7)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                _createVNode(_component_el_radio, {
                                  modelValue: customerOperateType.value,
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((customerOperateType).value = $event)),
                                  label: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _unref(cT)('同款链接')
                                    }, null, 8, _hoisted_50)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                (__props.rowItem.purchaseUserProductLink)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                      _createElementVNode("a", {
                                        target: "_blank",
                                        href: __props.rowItem.purchaseUserProductLink
                                      }, _toDisplayString(__props.rowItem.purchaseUserProductLink) + "(" + _toDisplayString(_unref(t)('点击可查看')) + ")", 9, _hoisted_52),
                                      _createElementVNode("span", null, "(" + _toDisplayString(__props.rowItem.purchaseProductProp.replace(/[+-]?\d+:[+-]?\d+:/ig, '')) + ")", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (__props.rowItem.abnormalDetailType === 5)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _createVNode(_component_el_radio, {
                                  modelValue: customerOperateType.value,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((customerOperateType).value = $event)),
                                  label: 7
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _unref(cT)('类似款链接')
                                    }, null, 8, _hoisted_54)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                (__props.rowItem.purchaseUserProductLink)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                      _createVNode(AppLink, {
                                        to: __props.rowItem.purchaseUserProductLink,
                                        target: "_blank"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(__props.rowItem.purchaseUserProductLink) + "(" + _toDisplayString(_unref(t)('点击可查看')) + ") ", 1)
                                        ]),
                                        _: 1
                                      }, 8, ["to"]),
                                      _createElementVNode("span", null, "(" + _toDisplayString(__props.rowItem.purchaseProductProp.replace(/[+-]?\d+:[+-]?\d+:/ig, '')) + ")", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (__props.rowItem.type === 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                _createVNode(_component_el_radio, {
                                  modelValue: customerOperateType.value,
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((customerOperateType).value = $event)),
                                  label: 8
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _unref(cT)('等待原链接')
                                    }, null, 8, _hoisted_57)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          ((__props.rowItem.type === 6) || (__props.rowItem.type === 5 && __props.rowItem.abnormalDetailType === 4))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                _createVNode(_component_el_radio, {
                                  modelValue: customerOperateType.value,
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((customerOperateType).value = $event)),
                                  label: 8
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _unref(cT)('下单原链接')
                                    }, null, 8, _hoisted_59)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          (__props.rowItem.type === 5 && __props.rowItem.abnormalDetailType === 6)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                _createVNode(_component_el_radio, {
                                  modelValue: customerOperateType.value,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((customerOperateType).value = $event)),
                                  label: 10
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _unref(cT)('下单原链接（多出数量保留库存）')
                                    }, null, 8, _hoisted_61)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          ((__props.rowItem.type === 10) && [4, 6].includes(customerOperateType.value) && isHaveShopPurchase.value === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _createElementVNode("div", _hoisted_63, _toDisplayString(_unref(t)('请确认本次重拍费用')), 1),
                                _createElementVNode("p", null, [
                                  _createVNode(_component_el_radio, {
                                    "model-value": 13,
                                    label: 13
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('次品退货退款并付费重拍')) + " (" + _toDisplayString(_unref(t)('本次重拍费用X円').replace('X',
                  __props.rowItem.remakeMoney
                  ||
                  0)) + ")", 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                (__props.rowItem.payRepurchaseType !== 1)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_64, [
                                      _createVNode(_component_el_checkbox, {
                                        disabled: !(customerOperateType.value === 13),
                                        modelValue: payRepurchaseType.value,
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((payRepurchaseType).value = $event))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", {
                                            innerHTML: _unref(isD2C)() ? _unref(t)('以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。') : _unref(t)('以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。')
                                          }, null, 8, _hoisted_65)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "modelValue"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _createElementVNode("span", _hoisted_67, _toDisplayString(_unref(t)('处理结果')), 1),
              _createElementVNode("div", _hoisted_68, [
                (__props.rowItem.customerOperateType == 11)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_unref(cT)('良品入库')), 1))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 12)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_unref(cT)('不良品')), 1))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 13)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                      _createTextVNode(_toDisplayString(_unref(t)('次品退货退款并付费重拍')) + " (" + _toDisplayString(_unref(t)('本次重拍费用X円').replace('X', __props.rowItem.remakeMoney
                || 0)) + ") ", 1),
                      (__props.rowItem.payRepurchaseType === 1 && _unref(isD2C)())
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            innerHTML: _unref(t)('以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。')
                          }, null, 8, _hoisted_72))
                        : _createCommentVNode("", true),
                      (__props.rowItem.payRepurchaseType === 2 && !_unref(isD2C)())
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            innerHTML: _unref(t)('以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。')
                          }, null, 8, _hoisted_73))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 5)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(_unref(cT)('取消商品')), 1))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 14)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(_unref(t)('按原价采购')), 1))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_unref(t)('更换尺码')), 1))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_unref(t)('更换颜色')), 1))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(_unref(t)('更换款式')), 1))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 14)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(_unref(t)('按原价采购')), 1))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 15)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_80, [
                      _createElementVNode("span", {
                        innerHTML: _unref(cT)('换个链接')
                      }, null, 8, _hoisted_81),
                      _createElementVNode("a", {
                        href: __props.rowItem.customerProductLink,
                        target: "_blank"
                      }, "(" + _toDisplayString(__props.rowItem.customerProductLink) + ")", 9, _hoisted_82)
                    ]))
                  : _createCommentVNode("", true),
                ([1, 2, 3].includes(__props.rowItem.customerOperateType))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_83, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productSkuList.value, (v, index) => {
                        return (_openBlock(), _createElementBlock("span", { key: index }, [
                          (__props.rowItem.customerProductSku === v.productSku)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(v.props), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType==4)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_85, [
                      _createElementVNode("span", {
                        innerHTML: _unref(cT)('换个链接')
                      }, null, 8, _hoisted_86),
                      _createElementVNode("a", {
                        href: __props.rowItem.customerProductLink,
                        target: "_blank"
                      }, "(" + _toDisplayString(__props.rowItem.customerProductLink) + ")", 9, _hoisted_87)
                    ]))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType==6)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_88, [
                      _createElementVNode("span", {
                        innerHTML: _unref(cT)('同款链接')
                      }, null, 8, _hoisted_89),
                      _createElementVNode("a", {
                        target: "_blank",
                        href: __props.rowItem.purchaseUserProductLink
                      }, _toDisplayString(__props.rowItem.purchaseUserProductLink) + "(" + _toDisplayString(_unref(t)('点击可查看')) + ")", 9, _hoisted_90),
                      _createElementVNode("span", null, "(" + _toDisplayString(__props.rowItem.purchaseProductProp?.replace(/[+-]?\d+:[+-]?\d+:/ig, '')) + ")", 1)
                    ]))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 7)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_91, [
                      _createTextVNode(_toDisplayString(_unref(cT)('类似款链接')) + " ", 1),
                      _createVNode(AppLink, {
                        to: __props.rowItem.purchaseUserProductLink,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.rowItem.purchaseUserProductLink) + "(" + _toDisplayString(_unref(t)('点击可查看')) + ") ", 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createElementVNode("span", null, "(" + _toDisplayString(__props.rowItem.purchaseProductProp.replace(/[+-]?\d+:[+-]?\d+:/ig, '')) + ")", 1)
                    ]))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType==8&&__props.rowItem.type === 4)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 14,
                      innerHTML: _unref(t)('等待原链接')
                    }, null, 8, _hoisted_92))
                  : _createCommentVNode("", true),
                _hoisted_93,
                (__props.rowItem.customerOperateType==8&&(__props.rowItem.type === 6) || (__props.rowItem.type === 5 && __props.rowItem.abnormalDetailType === 4))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_94, [
                      _createElementVNode("span", {
                        innerHTML: _unref(cT)('下单原链接')
                      }, null, 8, _hoisted_95)
                    ]))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType == 10 && __props.rowItem.type === 5 && __props.rowItem.abnormalDetailType === 6)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_96, [
                      _createElementVNode("span", {
                        innerHTML: _unref(cT)('下单原链接')
                      }, null, 8, _hoisted_97)
                    ]))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType === 16)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）正常发货')), 1))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType === 17)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）也取消发货，转为库存')), 1))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType === 18)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 19 }, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('该商品取消采购和发货，订单下其余商品（若有）自定义发货或转为库存')), 1),
                      _createElementVNode("div", _hoisted_100, [
                        _createVNode(productTable, {
                          tableData: tableData.value,
                          type: 3,
                          customerOperateType: 18
                        }, null, 8, ["tableData"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (__props.rowItem.customerOperateType === 19)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(_unref(t)('不能接受该不良，希望同商品换货（该换货无需重新冻结费用，如供应商无货，则系统会自动取消）')), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      (!__props.onlyRead)
        ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
            _createVNode(_component_el_button, {
              onClick: _cache[38] || (_cache[38] = ($event: any) => (emits('update:visible', false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (__props.onlyRead)
        ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[39] || (_cache[39] = ($event: any) => (emits('update:visible', false))),
              style: {"width":"200px","height":"40px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dialog, {
        modelValue: groupVisible.value,
        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((groupVisible).value = $event)),
        "custom-class": "problem-group-dialog"
      }, {
        default: _withCtx(() => [
          _hoisted_104,
          _createElementVNode("div", _hoisted_105, [
            _createVNode(_component_el_icon, { style: {"transform":"rotate(180deg)"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(WarningFilled))
              ]),
              _: 1
            }),
            _createElementVNode("span", null, _toDisplayString(_unref(t)('「已取消」或「已发货」或「待发货」或「触发异常联络未处理」的商品无法再次选择')), 1)
          ]),
          _createVNode(productTable, {
            tableData: tableData.value,
            customerOperateType: customerOperateType.value
          }, null, 8, ["tableData", "customerOperateType"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})